import { render, staticRenderFns } from "./SlideFullScreenImageGallery.vue?vue&type=template&id=35d30804&"
import script from "./SlideFullScreenImageGallery.vue?vue&type=script&lang=js&"
export * from "./SlideFullScreenImageGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports